import * as actions from './actions';

import {
  catchError, filter, map, switchMap, withLatestFrom,
} from 'rxjs/operators';

import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { AjaxResponse } from 'rxjs/ajax';
import { GetPackageDetailsAPIResponse } from './types';

export const getPackageDetailsEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) => action$.pipe(
  filter(isActionOf(actions.getPackageDetails.request)),
  withLatestFrom(state$),
  switchMap(([{ payload }, state]) => apiClient(state)
    .getPackageDetails(payload)
    .pipe(
      map((
        { response }: AjaxResponse<GetPackageDetailsAPIResponse>,
      ) => actions.getPackageDetails.success({ package: response.data.package })),
      catchError((error: Error) => of(actions.getPackageDetails.failure({ error }))),
    )),
);
